import './../style/solutions.css';
import { useTranslation } from "react-i18next";
import React, {useEffect, useRef, useState} from "react";
import {useScrollPosition} from "../hooks/useScrollPosition";

import hexagonFront from "../img/solutions/hexagonFront.svg";
import hexagonFrontDW from "../img/solutions/hexagonFrontDW.svg";
import hexagonBack from "../img/solutions/hexagonBack.svg";

/* Hexagon icons */
import iconCFIN from "../img/solutions/Icons/IkonaCFIN_2_biala.svg";
import iconDW from "../img/solutions/Icons/IkonaDATAWAREHOUSE_2_biala.svg";
import iconEDI from "../img/solutions/Icons/IkonaEDI_1_biala.svg";
import iconHFM from "../img/solutions/Icons/IkonaHFM_1_biala.svg";
import iconBPN from "../img/solutions/Icons/Business_Partner_Notification.svg";
import iconIMD from "../img/solutions/Icons/Item_Master_Data.svg";
import iconO2C from "../img/solutions/Icons/O2C_Integration_Proces.svg";
import iconExcell from "../img/solutions/Icons/Import_From_excel-02.svg";
import iconIntegrations from "../img/solutions/Icons/R2_Integrations-02.svg";
import iconAPons from "../img/solutions/Icons/APons_Custom-02.svg";


import Hexagons from './fragments/solutions/Hexagons';


function Kamilatest() {

    // Pop-ups
    const popups = [
        {Index: 1, Title: "Test1", Content: (<div></div>)},
        {Index: 2, Title: "Test2", Content: (<div></div>)},
    ];

    // Variables
    const [popup, setPopup] = useState(popups.find(p => p.Index === 1));

    // internationalization
    const {t} = useTranslation();

    // scroll to top
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // hexagon row transform
    const hexagonRows = document.querySelectorAll('.solutions-hexagon-row');

    hexagonRows.forEach((hexagonRow, index) => {
       hexagonRow.style.transform = `translate(0, ${(index - 1) * -25}%)`
    });

    // Choose popup and show it
    const choosePopup = (index) => {
        setPopup(popups.find(p => p.Index === index));
        changePopupVisibility();
    };

    // Change popup visibility
    const changePopupVisibility = () => {
        document.querySelectorAll(".solutions-popup-container")
            .forEach(p => p.classList
                .toggle("solutions-popup-container-hidden"));
    };

    // Create hexagons
    const hexagons = [
        {index: 1, name: "test1", img: iconDW, text: ['Data', 'Warehouse']},
        {index: 1, name: "test1", img: iconDW, text: ['Data', 'Warehouse2']},
        {index: 1, name: "test1", img: iconDW, text: ['Data', 'Warehouse']},
        {index: 1, name: "test1", img: iconDW, text: ['Data', 'Warehouse']},
        {index: 1, name: "test1", img: iconDW, text: ['Data', 'Warehouse']},
        {index: 1, name: "test1", img: iconDW, text: ['Data', 'Warehouse']},
        {index: 1, name: "test1", img: iconDW, text: ['Data', 'Warehouse']},
        {index: 1, name: "test1", img: iconDW, text: ['Data', 'Warehouse']},
        {index: 1, name: "test1", img: iconDW, text: ['Data', 'Warehouse']},
        {index: 1, name: "test1", img: iconDW, text: ['Data', 'Warehouse']},
    ];



    return (
        <div>
            ndaisdinsa
        </div>
    );
}

export default Kamilatest
